import { get } from "../fn";

export const getFirst = get(1);

/**
 * Parses GraphQL query and extracts the operation name
 *
 * @type {(query: string) => string}
 *
 */
export const getOperationName = query =>
	getFirst(/(?:query|mutation)\s+([^({\s]*)/m.exec(query)) || "";
